import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  background-color: #fff;
  min-height: 64vh;
  width: 100%;
`;

export const SwooshSVG = styled.img`
  position: absolute;
  top: -70px;
  right: 0;
  /* z-index: 1; */
  @media only screen and (min-width: 769px) {
    top: -150px;
  }
`;

export const TitleWrapper = styled.div`
  position: relative;
  width: calc(100% - 20px);
  left: 20px;

  @media only screen and (min-width: 769px) {
    left: 0px;
  }
`;

export const PageTitle = styled.div`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.091px;
  margin-bottom: 24px;

  @media only screen and (min-width: 769px) {
    margin-top: 32px;
    margin-bottom: 0px;
    font-size: 40px;
    line-height: 50px;
  }
`;

export const ContentWrapper = styled.div`
  margin-top: 100px;
  width: 100%;
  min-height: 100px;
  // height: auto;
  background-color: ${(props) => props?.bgColor ?? "inherit"};
  border-radius: 16px 16px 0 0;

  @media only screen and (min-width: 769px) {
    margin-top: 80px;
  }
`;

export const CarouselWrapper = styled.div`
  position: relative;
  top: -72px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  @media only screen and (min-width: 769px) {
    top: -172px;
  }
`;

export const StandingCardWrapper = styled.div`
  position: relative;
  top: -48px;
  width: 90%;
  margin-left: 5%;

  @media only screen and (min-width: 769px) {
    top: -128px;
    width: 100%;
    margin: 0;
  }
`;

export const InnerContentWrapper = styled.div`
  width: 100%;

  @media only screen and (min-width: 769px) {
    max-width: 1440px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
  }
`;
